// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function WithdrawError({ width = "73px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 73 78"
      width={width}
      {...props}
    >
      <g transform="translate(-509.987 -1291)">
        <g transform="translate(509.988 1293.066)">
          <g id="atm" transform="translate(0 18.381)">
            <rect
              fill="#64798a"
              width="51.206"
              height="14.279"
              transform="translate(6.314 0)"
            />
            <path
              fill="#3a556a"
              d="M148.269,40.613h-33.21a2.087,2.087,0,0,0,0,4.175h33.21a2.087,2.087,0,0,0,0-4.175Z"
              transform="translate(-99.748 -35.926)"
            />
            <rect
              fill="#3ea69b"
              width="28.09"
              height="40.27"
              transform="translate(17.871 4.692)"
            />
            <path
              fill="#44c4a1"
              d="M169.786,40.656V75.773a3.133,3.133,0,0,1,3.128,3.139h17.821a3.133,3.133,0,0,1,3.128-3.139V40.656Z"
              transform="translate(-149.908 -35.964)"
            />
            <g transform="translate(22.334 9.671)">
              <ellipse
                fill="#3ea69b"
                cx="9.582"
                cy="7.597"
                rx="9.582"
                ry="7.597"
              />
              <ellipse
                fill="#3ea69b"
                cx="1.713"
                cy="1.719"
                rx="1.713"
                ry="1.719"
                transform="translate(7.869 27.394)"
              />
            </g>
            <path
              fill="#44c4a1"
              d="M222.155,110.53H220.8a8.126,8.126,0,0,1-2.029,4.6l-1.62-1.364a6.49,6.49,0,0,0,1.62-3.233h-3.612a7.638,7.638,0,0,1-1.322,3.093,2.985,2.985,0,0,1-2.43.981,3.393,3.393,0,0,1-2.635-1.13,4.586,4.586,0,0,1-1.117-2.944h-.931v-1.2h.949a7.829,7.829,0,0,1,1.4-3.887l1.713,1.215a6.04,6.04,0,0,0-1.08,2.672h3.5v-.056a7.591,7.591,0,0,1,1.359-3.157,3.077,3.077,0,0,1,2.486-1.01,3.374,3.374,0,0,1,2.653,1.159,4.826,4.826,0,0,1,1.117,3.064h1.34v1.2Zm-12.017,1.318a1.33,1.33,0,0,0,1.042.476,1.31,1.31,0,0,0,.986-.374,3.779,3.779,0,0,0,.7-1.42h-3.221A2.243,2.243,0,0,0,210.138,111.848Zm8.163-3.934a1.435,1.435,0,0,0-2.113-.113,4.093,4.093,0,0,0-.717,1.533h3.351A2.619,2.619,0,0,0,218.3,107.915Z"
              transform="translate(-182.522 -92.851)"
            />
            <path
              fill="#fcd462"
              d="M60.875,157.645a2.157,2.157,0,0,0-2.573.111l-6.647,5.4a1.586,1.586,0,0,1-2.519-.752,5.488,5.488,0,0,1-.187-.913,1.581,1.581,0,0,1,1.033-1.662l.883-.326V153.57l-5.572.941a5,5,0,0,0-4.1,4.124L37.38,181.928,48.466,185c5.882-5.829,7.076-9.854,7-13.1A8.545,8.545,0,0,1,57.1,166.73l4.322-6.029A2.168,2.168,0,0,0,60.875,157.645Z"
              transform="translate(-32.994 -135.619)"
            />
            <path
              fill="#64798a"
              d="M0,0,20.116.019l.008,8.356L.008,8.356Z"
              transform="translate(19.336 57.553) rotate(-163.936)"
            />
            <path
              fill="#fff"
              d="M1.515,0A1.519,1.519,0,1,1,0,1.518,1.522,1.522,0,0,1,1.515,0Z"
              transform="translate(18.905 54.66) rotate(-163.936)"
            />
            <path
              fill="#3a556a"
              opacity="0.5"
              d="M150.349,42.7a2.084,2.084,0,0,0-2.08-2.087h-33.21a2.084,2.084,0,0,0-2.08,2.087"
              transform="translate(-99.748 -35.926)"
            />
          </g>
          <g transform="translate(47.004 0)">
            <circle fill="#f63f27" cx="12.998" cy="12.998" r="12.998" />
            <path
              fill="#fff"
              d="M48.968,46.436l3.83-3.83a1.083,1.083,0,0,0-1.532-1.532l-3.83,3.83-3.83-3.83a1.083,1.083,0,1,0-1.532,1.532l3.83,3.83-3.83,3.83A1.083,1.083,0,1,0,43.606,51.8l3.83-3.83,3.83,3.83A1.083,1.083,0,1,0,52.8,50.266Z"
              transform="translate(-34.438 -33.438)"
            />
          </g>
        </g>
        <path
          fill="#00c0f4"
          d="M18.664,8.4,10.12.2A.721.721,0,0,0,9.136.187L.092,8.4a.279.279,0,0,0,.187.486H3.507a.726.726,0,0,1,.725.728v8.255a.553.553,0,0,0,.552.554h9.154a.553.553,0,0,0,.552-.554V9.611a.726.726,0,0,1,.725-.728h3.257A.279.279,0,0,0,18.664,8.4Z"
          transform="translate(551.756 1309.42) rotate(180)"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/WithdrawError.js